export const Server = {
  endpoint: 'https://app.news.travel/v1',
  project: '619e27fe198b7',
  propertiesCollectionID: '619e280a75d28',
  postsCollectionID: '61cc7cece2063',
  widgetsCollectionID: '61d462a0e66ee',
  categoriesCollectionID: '61d6d257a5ee35312fe2',
  typesCollectionID: '61d6d491b060c3c6351b'
}
